import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    height: 55,
    width: 'auto',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.img}
      src="/Konecta_Logo_RGB_White.png"
      alt="Konecta"
    />
  );
};

export default LogoFull;
